module.exports = require("./nds");